function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5186,
  r: 11,
  stroke: "url(#paint0_linear_12942_3958)",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_12942_3958",
  x1: 0,
  y1: 12.8112,
  x2: 24,
  y2: 12.8112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E64B4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1875,
  stopColor: "#F3795E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.359375,
  stopColor: "#E4BC5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526042,
  stopColor: "#39D68D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.682292,
  stopColor: "#37B1E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84375,
  stopColor: "#874FC6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F05576"
})));

function SvgIconQuincyChat(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuincyChat);
export default __webpack_public_path__ + "static/media/icon-quincy-chat.dc62019fe5f540a6a854c4f1f9e50851.svg";
export { ForwardRef as ReactComponent };